// Instellingen als overzicht (Duits). Zelfde vorm als settingsHub.nl.ts.
export const appSettingsHubDe = {
    groups: {
        family: {
            title: 'Unsere Familie',
            titleHouse: 'Unser Haushalt',
            body: 'Wer dazugehört, die Sprache und was zu euch passt.',
        },
        agenda: {
            title: 'Kalender',
            body: 'Kalender von außen einbinden, teilen und exportieren.',
        },
        board: {
            title: 'Board und Tablets',
            body: 'Die Tablets an der Wand, die Zimmer, die Sperre und das Wetter.',
        },
        modules: {
            title: 'Module',
            body: 'Welche Bereiche ihr nutzt, jeweils mit eigenen Einstellungen.',
        },
        account: {
            title: 'Dein Konto',
            body: 'Anmeldung und Sicherheit, Mitteilungen auf deinem Handy und wie die App aussieht.',
        },
        privacy: {
            title: 'Datenschutz und Daten',
            body: 'Deine Daten herunterladen oder löschen, und wer mitschauen darf.',
        },
    },
    household: {
        title: 'Haushalt',
        intro: 'Name, Sprache und Art des Haushalts an einem Ort.',
        nameTitle: 'Name und Zeitzone',
        nameBody: 'Der Name steht auf dem Board und in den E-Mails.',
    },
    calendar: {
        title: 'Kalender verbinden und exportieren',
        intro: 'Abo-Links, Fahrzeit und der Kalender als Datei.',
    },
    locationWeather: {
        title: 'Ort und Wetter',
        intro: 'Wo ihr wohnt, und was das Board über das Wetter zeigt.',
    },
    // WP3: vijf onderdelen, Bord en Gezin met tabbladen.
    sections: {
        label: 'Bereiche der Einstellungen',
        household: 'Haushalt',
        family: 'Familie und Traditionen',
        house: 'Was zu unserem Zuhause passt',
        agenda: 'Kalender',
        modules: 'Module',
        account: 'Konto und Datenschutz',
        accountState: 'Sicherheit, Mitteilungen, Design und deine Daten',
    },
    change: 'Ändern',
    /** Rechts in een regel die alleen uitleg opent (geen keuze). */
    view: 'Ansehen',
    rows: {
        name: 'Name und Zeitzone',
        language: 'Sprache',
        type: 'Art des Haushalts',
        location: 'Standort',
        weather: 'Wetter auf dem Board',
        feeds: 'Externe Kalender',
        feedsState: 'Schule, Sport und Arbeit in eurem Kalender',
        sync: 'Google oder Outlook verbinden',
        syncState: 'In beide Richtungen, pro Person',
        links: 'Abo-Links',
        linksState: 'Euer Kalender in einer anderen App (eine Richtung)',
        export: 'Exportieren',
        exportState: 'Der Kalender als Datei (.ics)',
        theme: 'Design und Piktogramme',
        about: 'Über AMUMIN',
        off: 'Aus',
        nothing: 'Noch nichts gewählt',
        ownChoices: 'Eigene Auswahl: {names}',
    },
    hubs: {
        board: {
            title: 'Board',
            tabs: 'Bereiche des Boards',
            view: 'Ansicht',
            tablets: 'Tablets',
            rooms: 'Räume',
            frame: 'Bilderrahmen',
            kidLock: 'Kindersperre',
        },
        family: {
            title: 'Familie',
            tabs: 'Bereiche der Familie',
            members: 'Mitglieder',
            links: 'Verwandte',
            circle: 'Kreis',
        },
    },
    tablets: {
        none: 'Noch kein Tablet verbunden.',
        guide: 'So verbindest du ein iPad',
    },
    members: {
        order: 'Reihenfolge',
        orderDone: 'Fertig',
    },
    modulesCount: '{on} von {total} an',
    privacyStatement: 'Datenschutzerklärung',
    privacyStatementBody: 'Was wir speichern, warum und wie lange.',
    haptics: {
        label: 'Vibrieren beim Tippen',
        hint: 'Eine kurze Vibration, wenn du etwas drückst (nur auf einem Handy, das das kann).',
        boardHint: 'Eine kurze Vibration, wenn jemand auf der Tafel etwas drückt. Ein iPad vibriert nicht; dort sieht man das Drücken trotzdem.',
    },
};
//# sourceMappingURL=settingsHub.de.js.map